// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2d6d9347]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.flowGrid[data-v-2d6d9347] {\n  display: flex;\n  flex-wrap: wrap;\n}\n", ""]);
// Exports
module.exports = exports;
